import clsx from "clsx";
import React from "react";

export type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  rounded?: boolean;
  error?: boolean;
};

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea({ rounded, error, className, rows = 5, ...props }, forwardedRef) {
  return (
    <textarea
      rows={rows}
      className={clsx(
        // NOTE: Using font-size less than 16px, zooms the input in on ios and doesn't zoom back after blur.
        "form-control",
        "tw-text-base sm:tw-text-sm",
        "tw-outline-none focus-visible:tw-ring-1",
        // Same redesign-v1 opt-in as `Input` above: `rounded` implies we're inside `[data-redesign-v1]`,
        // so swap the Bootstrap `.form-control` blue border/ring for the redesign's neutral tokens
        // (tw-* utilities carry `!important`, so they win over the non-important Bootstrap class).
        rounded ? "tw-border-border tw-text-foreground tw-ring-ring" : "tw-ring-blue-600",
        { "tw-border-red-600": error },
        { "tw-rounded-md": rounded },
        className,
      )}
      ref={forwardedRef}
      {...props}
    />
  );
});
